// AWS Amplify Gen 2 Configuration
import { Amplify } from 'aws-amplify';
import outputs from './amplify_outputs.json';

// Configure Amplify with Gen 2 outputs
export function configureAmplify() {
  try {
    // Configure with outputs - Amplify Gen 2 handles storage automatically
    Amplify.configure(outputs);
    console.log('✅ Amplify Gen 2 configured');
    console.log('Auth region:', outputs.auth.aws_region);
    console.log('User pool:', outputs.auth.user_pool_id);
  } catch (error) {
    console.error('❌ Amplify configuration error:', error);
    console.log('ℹ️  Make sure you have run: npx ampx sandbox');
  }
}

export default outputs;
